import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSolution } from './components/ProblemSolution';
import { FeaturedGames } from './components/FeaturedGames';
import { HowItWorks } from './components/HowItWorks';
import { About } from './components/About';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen w-full bg-brand-offwhite selection:bg-brand-lime selection:text-brand-navy" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSolution data-id="element-2" />
      <FeaturedGames data-id="element-3" />
      <HowItWorks data-id="element-4" />
      <About data-id="element-5" />
      <Footer data-id="element-6" />
    </main>;
}